import { Routes, Route } from 'react-router-dom';
import { paymentRoutes } from '../../routes/paymentRoutes';

const PaymentPage = () => {
  return (
    <div>
      <Routes>
        {paymentRoutes?.map(route => (
          <Route
            path={route.path}
            element={
              <div>
                <route.component />
              </div>
            }
            key={route.path}
          />
        ))}
      </Routes>
    </div>
  );
};

export default PaymentPage;
